// Clipboard helper with a legacy fallback.
//
// navigator.clipboard is only exposed in a *secure context* (https:// or
// localhost). This console is routinely served over plain http:// on an IP, and
// there navigator.clipboard is undefined — a Copy button wired straight to it
// silently does nothing. copyText falls back to the deprecated-but-universally
// -supported execCommand path so one click copies however the page is served.
export async function copyText(text: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      /* permission denied or document not focused — fall through */
    }
  }
  return legacyCopy(text);
}

function legacyCopy(text: string): boolean {
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    // Off-screen but still selectable: display:none or visibility:hidden makes
    // the selection, and therefore the copy, fail.
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.left = '-9999px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);

    const previous = document.getSelection()?.rangeCount
      ? document.getSelection()!.getRangeAt(0)
      : null;

    ta.select();
    ta.setSelectionRange(0, ta.value.length);
    const ok = document.execCommand('copy');

    document.body.removeChild(ta);
    if (previous) {
      const sel = document.getSelection();
      sel?.removeAllRanges();
      sel?.addRange(previous);
    }
    return ok;
  } catch {
    return false;
  }
}
